// extracted by mini-css-extract-plugin
module.exports = {"arrowGesture":"Gestures_arrowGesture__31Kuy","arrowPath":"Gestures_arrowPath__3MMc5","anchor":"Gestures_anchor__1q-58","ship":"Gestures_ship__8pQ_-"};